import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Form, Field, Button, Toast, List, PullRefresh, Popup, Picker, RadioGroup, Radio, DatetimePicker, Icon } from 'vant';
import 'vant/lib/index.css';
import axios from './axios'

Vue.use(axios);
Vue.use(Form).use(Field).use(Button).use(Toast).use(List).use(PullRefresh).use(Popup).use(Picker).use(RadioGroup).use(Radio).use(DatetimePicker).use(Icon)
router.beforeEach((to, from, next) => {
  window.scrollTo(0,0);
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  setTimeout(() => {
    next()
  }, 200);
})

Vue.config.productionTip = false

Vue.prototype.wechatApplet = function(){
  var url = window.location.href;
  this.locationHref = url.split("?")[0];
  // console.log(this.locationHref)
  this.axios.get("/wx/mp/getWeJsTicket",{params:{url:url}})
  .then(res=>{
    console.log(res)
    wx.config({
      appId: res.appId,
      timestamp: res.timestamp,
      nonceStr: res.nonceStr,
      signature: res.signature,
      jsApiList: [
        "onMenuShareTimeline","openLocation","chooseImage","uploadImage","scanQRCode"
      ], // 必填，需要使用的JS接口列表
      openTagList: [
        'wx-open-launch-weapp'
      ]
    });
    wx.ready(()=>{
      var btn = document.getElementById('launch-btn');
      btn.addEventListener('launch', function (e) {
        console.log('suc', e.detail);
      });
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail);
      });
    })
    wx.error(function(res){
    })
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
